export default "__VITE_ASSET__B6Ny$QvR__"